module.exports = __webpack_public_path__ + "static/img/1.2b6ae89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avtar/1.jpg
// module id = F80L
// module chunks = 36